// extracted by mini-css-extract-plugin
export var h1 = "layout-module--h-1--tdU0a";
export var h2 = "layout-module--h-2--15bmU";
export var h3 = "layout-module--h-3--v4KoK";
export var genHeader = "layout-module--gen-header--1tkJ2";
export var p1 = "layout-module--p-1--1kRzO";
export var p2 = "layout-module--p-2--wxR6T";
export var p3 = "layout-module--p-3--38vrF";
export var layout = "layout-module--layout--22H26";